import React, { Component } from "react";
import classnames from "classnames";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";

import { IItem } from "./IItem";
import * as styles from "./index.scss";
import { Item } from "./Item";

export interface IItemListProps extends ITestableComponentProps {
    items: IItem[];
    className?: string;
    noIcons?: boolean;
    minimalUX?: boolean;
}

export class ItemList extends Component<IItemListProps> {
    public render() {
        const { items, className, noIcons, minimalUX } = this.props;

        return (
            <div className={classnames(styles["item-list"], className)}>
                {items.map((item, i) => {
                    if (noIcons) {
                        delete item.icon;
                    }

                    return (
                        <Item
                            key={item.key || i}
                            item={item}
                            minimalUX={minimalUX}
                            data-testid={`list-item-${item.label}`}
                        />
                    );
                })}
            </div>
        );
    }
}
